import Jed from 'jed';

import esES from 'i18n/es.json';
import enUS from 'i18n/en.json';
import frFR from 'i18n/fr.json';
import ptPT from 'i18n/pt.json';
import brPT from 'i18n/pt-br.json';
import itIT from 'i18n/it.json';

// Armenian, Khmer, Lao, Latvian, Slovak, Thai and Vietnamese were removed
// from here (see PR #5747, companion to #5746 which archived their .po
// files out of the LingoHub sync path). To reactivate one: restore its
// i18n/<code>.json import and its entry in `languages`, `platformLanguages`,
// `getLanguagesDisplay` and `messages` below, mirror it in
// utils/languageDetector.js (LANG_* constant, getDefaultLanguage,
// LANGUAGE_OPTIONS), and check the other PR #5747 diffs (dayjs locales,
// per-language PDFs/images/fonts) for anything else that branched on that
// language code.

// Languages platform is translated to
export const languages = {
  EN: 'en_us',
  ES: 'es_es',
  FR: 'fr_fr',
  PT: 'pt_pt',
  BR: 'pt_br',
  IT: 'it_it',
};

// Available Platform languages with codes
export const platformLanguages = [
  { name: 'English', code: languages.EN },
  { name: 'Español', code: languages.ES },
  { name: 'Français', code: languages.FR },
  { name: 'Português', code: languages.PT },
  { name: 'Português (Brasil)', code: languages.BR },
  { name: 'Italiano', code: languages.IT },
];

export const getLanguagesDisplay = (t, language) =>
  ({
    [languages.EN]: t('English'),
    [languages.ES]: t('Spanish'),
    [languages.FR]: t('French'),
    [languages.PT]: t('Portuguese'),
    [languages.BR]: t('Portuguese (BR)'),
    [languages.IT]: t('Italian'),
  })[language];

/**
 * Map function that iterates through language codes
 * @function mapLanguageCodes
 * @param {function} callback - Function that will be called for every language
 * @return {Array}
 */
export const mapLanguageCodes = callback =>
  Object.values(languages).map(language => {
    const lang = language.split('_')[0];
    return (callback && callback(lang)) || lang;
  });

export const getLangSuffix = selectedLanguage => {
  const lang = selectedLanguage ?? languages.EN;
  return lang.split('_')[0];
};

// Function that transforms language codes into names: ["sq_sq", ...] -> ["LAN_sq", ...]
export const languageCodesToNames = (inputArray, t) =>
  inputArray.map(element => t(`LAN_${element.split('_')[1]}`));

const messages = {
  en_us: enUS,
  es_es: esES,
  fr_fr: frFR,
  pt_pt: ptPT,
  pt_br: brPT,
  it_it: itIT,
};

const wrap =
  (i18n, fn) =>
  (...args) => {
    try {
      return i18n[fn](...args);
    } catch (error) {
      return args[0];
    }
  };

const getTranslationHandlers = lang => {
  const i18n = new Jed(messages[lang]);
  return {
    t: wrap(i18n, 'gettext'),
    dt: wrap(i18n, 'dgettext'),
    tn: wrap(i18n, 'ngettext'),
    dtn: wrap(i18n, 'dngettext'),
    tctxt: wrap(i18n, 'pgettext'),
    dtctxt: wrap(i18n, 'dpgettext'),
    tnctxt: wrap(i18n, 'npgettext'),
    dtnctxt: wrap(i18n, 'dnpgettext'),
    format: wrap(i18n, 'sprintf'),
    language: lang,
  };
};

export default getTranslationHandlers;
